import { Link } from 'react-router';

import { usePortalSession } from '../auth';
import { FeatureCard } from '../components/FeatureCard';
import { HomeBookingCard } from '../components/HomeBookingCard';
import { StatusCard } from '../components/StatusCard';
import { usePortalStatus } from '../hooks/usePortalStatus';

export function HomePage() {
  const portalStatus = usePortalStatus();
  const { user } = usePortalSession();

  return (
    <>
      <HomeBookingCard />

      <section className="hero">
        <div className="hero-content">
          <p className="eyebrow">
            HubSpot and Phonero integration
          </p>

          <h1>Book a phone and start calling.</h1>

          <p className="hero-description">
            Reserve an available Phonero telephone resource
            for your calling session. We present ourselves
            as one organization and always call from a YWAM
            number.
          </p>

          <div className="hero-actions">
            <Link
              className="primary-button button-link"
              to="/book"
            >
              Book a phone
            </Link>

            <Link
              className="secondary-button button-link"
              to="/my-booking"
            >
              View my booking
            </Link>
          </div>
        </div>

        <StatusCard state={portalStatus} />
      </section>

      <section className="portal-section">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Portal</p>
            <h2>What would you like to do?</h2>
          </div>
        </div>

        <div className="feature-grid">
          <FeatureCard
            title="Book a phone"
            description="Find and reserve an available Phonero telephone resource."
            action="Start booking"
            path="/book"
          />

          <FeatureCard
            title="My booking"
            description="View your active booking and Phonero login information."
            action="View booking"
            path="/my-booking"
          />

          <FeatureCard
            title="Events"
            description="View events, assigned users and reserved telephone resources."
            action="View events"
            path="/events"
            disabled={!user?.hasEventAccess && !user?.canCreateEvents}
          />

          <FeatureCard
            title="Help"
            description="We use this system to book phones for calling future students and others."
            action="More information"
            path="/help"
          />

{user?.isAdministrator ? (
            <FeatureCard
              title="Administration"
              description="Manage users, events and telephone resources."
              action="Open administration"
              path="/admin"
            />
          ) : null}
        </div>
      </section>
    </>
  );
}
